export const isQuerySearchable = (query = ''): boolean => !!query && !!query.match(/[a-z]{3}/i);
